import React from "react";

import { Button } from "@mui/material";

import { BaseButtonProps } from "./base/types";

export const TextButton: React.FC<BaseButtonProps> = ({ text, ...props }) => {
  return (
    <Button variant="text" {...props}>
      {text}
    </Button>
  );
};
